import { useState } from "react";
import { toast } from "sonner";
import { Trash2, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg, downloadFile } from "@/lib/api";

export const ResetScoresDialog = ({ days, onDone, fixedDay, label = "Reset dnia / wyniki", testid = "results-reset-btn" }) => {
  const [open, setOpen] = useState(false);
  const [day, setDay] = useState(fixedDay || "");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const close = () => { setOpen(false); setPassword(""); setDay(fixedDay || ""); };
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const win = window.self !== window.top ? window.open("", "_blank") : undefined;
    try {
      const { data } = await api.post("/admin/scores/reset", { password, day: day || null });
      try {
        await downloadFile({ path: `/admin/backups/${data.backup_id}/file.xlsx`, filename: data.filename, win });
      } catch { toast.error("Nie udało się pobrać kopii wyników"); }
      const n = data.deleted;
      const word = n === 1 ? "ocenę" : [2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100) ? "oceny" : "ocen";
      toast.success(`Reset wykonany: wymazano ${n} ${word}, konferansjer wraca do pierwszego występu`);
      close();
      onDone();
    } catch (err) { win?.close(); toast.error(errMsg(err)); }
    finally { setBusy(false); }
  };

  const ctl = "w-full h-11 px-3 rounded-xl bg-[#0B132B] border border-blue-500/20 focus:border-blue-500 outline-none text-sm mt-1";
  return (
    <>
      <button data-testid={testid} onClick={() => setOpen(true)} className="h-11 px-3 rounded-xl border border-red-500/40 text-red-300 hover:bg-red-500/10 text-sm font-semibold uppercase tracking-wide flex items-center gap-2"><Trash2 className="w-4 h-4" />{label}</button>
      <Dialog open={open} onOpenChange={(v) => !v && close()}>
        <DialogContent className="bg-[#1C2541] border-red-500/40 max-w-md" data-testid="reset-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl uppercase text-red-300">{fixedDay ? `Reset dnia: ${fixedDay}` : "Reset zawodów"}</DialogTitle></DialogHeader>
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-slate-300">Usunięte zostaną oceny wszystkich sędziów (punkty, odjęcia i komentarze), a konferansjer wróci do pierwszego występu dnia. Wyczyszczona zostanie też rejestracja zawodników (obecność na miejscu i ubezpieczenia z tego dnia). Przed resetem system tworzy kopię wyników w pliku Excel i od razu ją pobiera. Tej operacji nie można cofnąć.</p>
            {!fixedDay && (
            <label className="block text-xs text-slate-400">Zakres
              <select data-testid="reset-day-select" value={day} onChange={(e) => setDay(e.target.value)} className={ctl}>
                <option value="">Wszystkie dni – całe zawody</option>
                {days.map((d) => <option key={d} value={d}>Tylko: {d}</option>)}
              </select>
            </label>
            )}
            <label className="block text-xs text-slate-400">Hasło administratora
              <input data-testid="reset-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={ctl} autoComplete="current-password" />
            </label>
            <button data-testid="reset-confirm-btn" disabled={!password || busy} className="w-full h-11 rounded-xl bg-red-600 hover:bg-red-500 font-semibold disabled:opacity-40 flex items-center justify-center gap-2 uppercase tracking-wide">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />}Potwierdź RESET
            </button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
